<template>
  <div class="checkboxes-input">
    <label>
      {{ options.label }}
      <span v-if="options.required" class="required">*</span>
    </label>
    <table class="table table-hover table-bordered table-striped">
      <thead>
        <tr>
          <th scope="col" v-for="(column, iColumn) in options.columns" :key="iColumn">
            <div class="text-center">
              {{ column.title }}
            </div>
          </th>
          <th scope="col" class="text-center">
            Select
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(row, i) in options.rows">
          <tr :key="i" :class="{ 'row-selected': value.includes(row.uuid) }">
            <template v-for="(column, iColumn) in options.columns">
              <td :key="iColumn">
                {{ row[column.name] }}
              </td>
            </template>
            <td class="text-center">
              <label class="switch">
                <input type="checkbox"
                  :value="row.uuid"
                  :id="options.name + '[]'"
                  :checked="value.includes(row.uuid)"
                  :name="options.name + '[]'"
                  @change="validate($event)"/>
              </label>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
  import {
    validationClass,
    validationMessage
  } from '@/util/helpers'

  export default {
    name: 'TableSelectInput',
    props: {
      value: {
        type: Array
      },
      options: {
        type: Object,
        default () {
          return {
            label: '',
            name: '',
            required: false
          }
        }
      }
    },
    data () {
      return {
        isValid: true
      }
    },
    computed: {
      validationClass,
      validationMessage
    },
    methods: {
      validate (event = false) {
        let value = this.value
        if (event) {
          if (value.includes(event.target.value)) {
            value = value.filter((el) => event.target.value !== el)
          } else {
            value = [ ...value, event.target.value ]
          }
        }
        this.$emit('input', value)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/TableSelectInput.vue